// Utility: convert a route name to URL-safe slug
// "Aeroporti Rinas (TIA)" -> "aeroporti-rinas"
// "Dhërmi" -> "dhermi"
export const slugify = (str) => {
  if (!str) return "";
  return str
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // strip diacritics
    .toLowerCase()
    .replace(/[^\w\s-]/g, "") // remove non-word chars
    .trim()
    .replace(/[-\s]+/g, "-");
};

export const routeSlug = (destination) => `taxi-lushnje-${slugify(destination)}`;
